import * as React from 'react';

import { RootState } from '../store';

import { Dispatch, Action } from 'redux';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';
import { TOGGLE_THANKYOU } from '../store/login';
import { Photo, TOGGLE_SELECT_PHOTO, CLEAR_PHOTOS } from '../store/photos';
import { EmailRequest, PaymentResult, SEND_EMAIL } from '../store/webshop';
import fileDownload from 'js-file-download';

const mapStateToProps = (state: RootState) => ({
    login: state.login,
    photo: state.photo,
    bricks: state.photo.bricks,
    selected: state.photo.selected,
    webshop: state.webshop,
    communitybricks: state.photo.communitybricks,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    toggleThankyou: () => {
        dispatch({ type: TOGGLE_THANKYOU})
    },
    onSelect: (id: string) => (e?: React.MouseEvent<any>) => {
        if(e != undefined) {
            e.stopPropagation();
            e.preventDefault();
        }

        dispatch({ type: TOGGLE_SELECT_PHOTO, id });
    },
    onClear: () => {
        dispatch({ type: CLEAR_PHOTOS})
    },
    sendEmail: (request: EmailRequest) => {
        dispatch({ type: SEND_EMAIL, request})
    },
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {
    loaded: boolean,
    receiptNo?: string,
    vendor: string,
    order: LineItem[]
}

export interface LineItem {
    id: string,
    name: string,
    cost: number
}

class Thankyou extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            loaded: false,
            receiptNo: "",
            vendor: "",
            order: []
        }
    }

    componentDidMount() {
        if(this.props.webshop.result && this.props.webshop.vendor){
            this.setState({receiptNo: this.props.webshop.result.transaction_id, vendor: this.props.webshop.vendor, order: this.props.webshop.result.items})
        }
    }

    componentWillUnmount() {
        this.setState({receiptNo: ""});
    }

    onDownloadClick = (cart: Photo[]) => (e: React.MouseEvent<any>) => {
        let ticket = encodeURIComponent(this.props.login.ticket || "");

        let ids = cart.map(photo => photo.id).join(",");

        window.open(`/api/v1/download/original/${ids}?sbpportal-ticket=${ticket}`, "_blank");

        e.stopPropagation();
        e.preventDefault();
    }

    clearCart = () =>{
        
        this.props.onClear();

        this.props.toggleThankyou();
    }

  /*  sendEmail = () => {
        let email = this.buildEmail();
        this.props.sendEmail(email);
        this.setState({sendEmail : false}, () => this.props.toggleThankyou)
    } */

    buildEmail = () => {


        let items: LineItem[] =  this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)).map(photo => {

            let item = photo as Photo;
            return {
                id: item.id,
                name: item.cm_description as string,
                cost: this.props.webshop.orders.has(item.id) ? 0 : item.cost as number
            }

        });

        let to = "david.costigan@parashift.com.au";
        let subject = "Transaction Receipt for ";
        let subtotal = 50;
        let transaction_id = "1";
        


        return {
            to,
            subject,
            items,
            transaction_id,
            subtotal
        }
    }

    downloadFile = () => {
     
        let transactionid = this.state.receiptNo;
        let vendor = this.state.vendor;

        let items: string
        let total = 0;
        items = "";
        if(this.state.order){
            let orders = this.state.order;
            orders.forEach(order => {
                items += " "+order.id + "\t\t$" + order.cost.toFixed(2) +"\n";
                total += order.cost;
            })
        }

        let Text = "Thank you for your purchase\n\nTransaction ID: "+transactionid+" \nprovider: "+vendor+" \n \n Order Summary: \n \t\t Item \t\t\t\tPrice \n"+ items +" \n Subtotal: $"+total.toFixed(2);

        if(this.state.vendor.toLowerCase() == "paypal"){
            Text = "Thank you for your purchase\n\nOrder ID: "+transactionid+" \nprovider: "+vendor+" \n \n Order Summary: \n \t\t Item \t\t\t\tPrice \n"+ items +" \n Subtotal: $"+total.toFixed(2);

        }

        fileDownload(Text, this.state.receiptNo+".txt");
    }

    public render() {
        let cart = this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)) as Photo[];

        let community = this.props.communitybricks.filter(communitybricks => communitybricks.type == "photo" && this.props.selected.has(communitybricks.id)) as Photo[];

        let newCart: Photo[] = [];

        cart = cart.concat(community);

        cart.forEach(element => {
            let found = false;
            for(var i=0; i < newCart.length; i++){
                if(newCart[i].id == element.id){
                    found = true;
                    continue;
                }
            }
            if(!found){
                newCart.push(element);
            }
            
        });

        cart = newCart
        let receiptID = <div className="pb-15">Transaction Id: {this.state.receiptNo}</div>
        if(this.state.vendor.toLowerCase() == "paypal"){
            receiptID = <div className="pb-15">Order Id: {this.state.receiptNo}</div>
        }
        

        return (
            <div className="checkout-section pt-90 pb-100">
                <div className="container">
                    <div className="checkout-form">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3">
                                <div className="order-confirm-sheet">
                                    <p className="pb-30"><img src="/api/asset/logo" alt="" width="180px" height="auto"></img></p>
                                    <img className="checkout-lock" src="/assets/icons/confirmed.png" height="30px"></img>
                                    <h2 className="main-title">Your purchase has been placed.</h2>
                                    {receiptID}
                                    <div className="order-review">
                                        <div className="pb-15">Your pictures are available to be downloaded.</div>
                                        <div className="pb-30">Click on the button below, and save the compressed Zip file.</div>
                                        <div className="pb-70">
                                             <a className="btn btn-add-cart btn-block float-center" onClick={this.onDownloadClick(cart)}><img className="add-cart-white" src="/assets/icons/download.png" height="26px" width="auto"></img><img className="add-cart-blue" src="/assets/icons/download_blue.png" height="26px" width="auto"></img> Download photos</a>
                                        </div>
                                        <div className="pb-70">
                                            <a className="btn btn-download btn-block" onClick={this.downloadFile}><img className="download_white" src="assets/icons/download.png" height="26px" width="auto" /><img className="download_green" src="assets/icons/download_green.png" height="26px" width="auto"/> Download Receipt</a>
                                        </div>
                                    <div>
                                        <a className="text-muted" onClick={this.clearCart} style={{cursor: "pointer"}}><img className="checkout-lock" src="/assets/icons/chevron_left.png"></img> Back to <strong>Gallery</strong></a>
                                    </div>
                                    </div>
                                </div>
                                <div className="mt-50">
                                    <p className="float-right">Powered by <img src="/assets/icons/logo.jpg" alt="" width="160px" height="auto" /></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Thankyou);